import styled from 'styled-components';

export const Content = styled.div``;

/*
 * The requester cell — the design's thumbnail-and-name pair, at the small
 * size it uses inside a detail grid rather than the 40px circle this screen
 * drew.
 */
export const Grid = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s2);
  min-width: 0;
`;

export const Name = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
